import { Button } from '@teamsparta/stack-button';
import { Flex } from '@teamsparta/stack-flex';
import { Text } from '@teamsparta/stack-text';
import { vars } from '@teamsparta/stack-tokens';
import type { MouseEvent } from 'react';

import { useLoginModal } from '@/store/login';

import * as S from './style';

interface Props {
  postId: string;
}

export function BluredPoll({ postId }: Props) {
  const { open, setNextPage } = useLoginModal();

  function handleClick(event: MouseEvent<HTMLDivElement>) {
    event.preventDefault();
    event.stopPropagation();

    open();
    setNextPage(`/community/post/${postId}`);
  }

  return (
    <Flex.Column
      fullWidth
      style={{
        cursor: 'pointer',
        borderRadius: '8px',
        border: `1px solid ${vars.neutral[80]}`,
        position: 'relative',
        overflow: 'hidden',
      }}
      onClick={handleClick}
    >
      <Flex.Column
        fullWidth
        gap={6}
        style={{
          filter: 'blur(6px)',
        }}
      >
        {['선택지 1', '선택지 2'].map((optionText, index) => (
          <Flex.Row
            key={`${optionText}-${index}`}
            fullWidth
            justify='between'
            padding='10px 12px'
            style={{
              position: 'relative',
              overflow: 'hidden',
              border: `1px solid ${
                index === 0 ? 'rgba(255, 92, 92, 0.40)' : vars.neutral[80]
              }`,
              borderRadius: '999px',
            }}
          >
            <Text
              as='span'
              font='captionSb'
              color={vars.neutral[30]}
              style={{ zIndex: 1 }}
            >
              {optionText}
            </Text>
            <Text
              as='span'
              font='captionSb'
              color={index === 0 ? vars.brand.strong : vars.neutral[50]}
              style={{ zIndex: 1 }}
            >
              {50}% ({50})
            </Text>
            <S.PollProgressBar
              percentage={50}
              isMostSelectedOption={index === 0}
            />
          </Flex.Row>
        ))}
      </Flex.Column>
      <Button
        size='sm'
        radius='rounded'
        colorScheme='secondary'
        style={{
          width: '100px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        결과 보기
      </Button>
    </Flex.Column>
  );
}
